export function typedFromEntries<K extends PropertyKey, V>(entries: [K, V][]) {
  return Object.fromEntries(entries) as Record<K, V>;
}

export function typedEntries<K extends PropertyKey, V>(entries: Record<K, V>) {
  return Object.entries(entries) as [K, (typeof entries)[K]][];
}

export function typedKeys<K extends PropertyKey>(entries: Record<K, unknown>) {
  return Object.keys(entries) as K[];
}
